"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
define('rs/modals/system.report.modal/system.report.modal.controller',['require','exports','module','e3-modal','./system.report.modal.view','model/report'],function (require, exports, module) {
  var E3Modal = require('e3-modal');
  var SystemReportModalView = require('./system.report.modal.view');
  var Report = require('model/report');
  var SystemReportModalController = E3Modal.SectionController.extend({
    defaultTitle: 'Find Sponsors',
    buttons: [{
      text: 'Cancel',
      dismiss: true,
      action: 'Cancel'
    }, {
      text: 'Confirm',
      color: 'primary',
      action: 'Confirm',
      ariaControls: '',
      dismiss: true
    }],
    initialize: function initialize() {
      var _this$props;
      this.systemReportOneModel = new Report();
      this.systemReportTwoModel = new Report();
      this._super.apply(this, arguments);
      this.title = this === null || this === void 0 || (_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.title;
      this.systemReportOneModel.getLookupValues(this.props.systemReportInputOne);
      this.systemReportTwoModel.getLookupValues(this.props.systemReportInputTwo);
    },
    getTemplateProperties: function getTemplateProperties() {
      return _objectSpread({}, this.props);
    },
    setupView: function setupView() {
      this.setView(new SystemReportModalView());
    },
    requestSaveItems: function requestSaveItems(formData) {
      this.reportModel.set('formData', formData);
    }
  }, {
    show: function show(model, modalOptions) {
      return E3Modal.SectionController.show.apply(this, arguments);
    }
  });
  module.exports = SystemReportModalController;
});

